/* la-chat.js — any link to "#chat" opens the Tidio chat window.

   Tidio loads late (theme.liquid starts it on idle), so a click can come
   before tidioChatApi exists or is ready. Calls made before "ready" are
   queued by Tidio itself; if Tidio never arrives (blocked by an extension,
   say), the link falls back to email after a few seconds so it is never
   dead. Set data-chat-fallback on the link to change the address. */
(function () {
  if (window.__laChat) return;
  window.__laChat = true;

  var FALLBACK = 'mailto:service@lifeartvision.com';
  var WAIT_MS = 4000;

  function openNow() {
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="#chat"]');
    if (!link) return;
    e.preventDefault();

    if (window.tidioChatApi) {
      openNow();
      return;
    }
    var done = false;
    document.addEventListener('tidioChat-ready', function () {
      if (done) return;
      done = true;
      openNow();
    }, { once: true });
    setTimeout(function () {
      if (done) return;
      done = true;
      window.location.href = link.getAttribute('data-chat-fallback') || FALLBACK;
    }, WAIT_MS);
  });
})();
